<template>
	<div
		class="lcd-readonly"
		:class="{ 'lcd-hover': hovered }"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
	>
		<!-- <span class="lcd-content">{{ text || displayed }}</span> -->
		<span class="lcd-content">{{ displayed }}</span>
	</div>
</template>

<script setup lang="ts">
	import { computed, getCurrentInstance, ref } from "vue";

	const props = defineProps<{ text?: string }>();
	// let text = props.text;

	// if (typeof text !== "string") {
	//   // @ts-ignore
	//   const el = getCurrentInstance()?.vnode?.props?.data?.id;
	//   console.log("LCDReadOnly: id =", el);
	//   // Oppure passa tu un "id" via props se vuoi!
	//   console.log("window.__lcdTexts =", (window as any).__lcdTexts);
	//   console.log("window.__lcdTexts[el] =", (window as any).__lcdTexts?.[el]);
	//   if ((window as any).__lcdTexts && el && (window as any).__lcdTexts[el]) {
	//     text = (window as any).__lcdTexts[el];
	//   } else {
	//     text = "Caricamento in corso...";
	//   }
	// }
	const inst = getCurrentInstance()!;
	const controlId = inst.vnode.props?.data?.id as string;

	// --- reactive map globale (già popolata da data.vue) ---
	const allTexts = () => (window as any).__lcdTexts || {};

	// --- computed che sceglie fra props.text (prima render) e poi la mappa globale ---
	const displayed = computed(() => {
		if (typeof props.text === "string") {
			return props.text;
		}
		return allTexts()[controlId] || "Caricamento in corso…";
	});
	const hovered = ref(false);
</script>

<style scoped>
	.lcd-readonly {
		font-family: "Share Tech Mono", "Consolas", monospace;
		background: #071c12;
		color: #b5ff48;
		border-radius: 10px;
		border: 2px solid #41fc86;
		padding: 0.7em 1em;
		font-size: 1.2rem;
		letter-spacing: 2px;
		box-shadow: 0 0 14px #61ff99b8 inset, 0 0 7px #35fd72;
		min-width: 120px;
		min-height: 6.4em;
		white-space: pre-line;
		overflow: hidden;
		text-overflow: ellipsis;
		transition: all 0.3s cubic-bezier(0.4, 2, 0.2, 1);
		max-height: 2.8em; /* mostra solo una riga circa */
		cursor: pointer;
	}

	.node.selected .lcd-readonly.lcd-hover {
		background: #172d16;
		color: #d8ffb8;
		font-size: 1.4rem;
		min-height: 12em;
		max-height: 22em;
		overflow: auto;
		box-shadow: 0 0 36px #adfd90, 0 0 25px #41fc86b8 inset;
		z-index: 20;
	}
	.lcd-content {
		display: block;
		user-select: text;
		white-space: pre-line;
		word-break: break-word;
	}
</style>
